import { createContext, useCallback, useEffect, useMemo, useState } from "react";
import { io } from "socket.io-client";
import { useSelector } from "react-redux";

const SocketContext = createContext(null);

const SocketProvider = ({ children }) => {
  // wrapper component that sets up and manages the socket connection

  // isOnline: admin's own online status
  const { isOnline, isAdmin } = useSelector(
    (state) => state.user
  );
  const [socket, setSocket] = useState(null);

  const createSocket = useCallback(() => {
    // create new Socket
    const newSocket = io(`${process.env.REACT_APP_API_URL}`, {transports: ['websocket', 'polling', 'flashsocket']
  });
  // , query: queryObject
    setSocket(newSocket);

    return newSocket;

  }, []);

  const disconnectSocket = useCallback(() => {
    if (socket) {
      socket.disconnect();
      setSocket(null);
    }
  }, [socket]);

  useEffect(() => {
    // user: create new socket (admin creates sockets when they go online...in AdminChats)
    // admin: if status is online but not socket exists, create one (was disconnected)
    if (!socket) {
      if (!isAdmin || (isAdmin && isOnline)) {
        createSocket();
      } 
    }
  }, [socket, isAdmin, isOnline, createSocket]);

  useEffect(() => {
    // on dismount, clean up socket
    return () => disconnectSocket();
  }, [isAdmin, disconnectSocket]);
  

  const contextValue = useMemo(() => ({
    socket, createSocket, disconnectSocket
  }), [socket, createSocket, disconnectSocket])

  return (
    <SocketContext.Provider value={contextValue}>
      {children}
    </SocketContext.Provider>
  );
};

export { SocketContext, SocketProvider };
